import React from 'react';
import PropTypes from 'prop-types';

function ShopSellLicensesPanel({ licenses }) {
  const items = Array.isArray(licenses) ? licenses : [];

  return (
    <div
      className='shop-sell-licenses-panel'
      style={{
        margin: '0 0 1rem',
        padding: '12px 14px',
        borderRadius: '10px',
        border: '1px solid #e8ecf1',
        background: '#f8fafc',
      }}
    >
      <div
        style={{
          fontSize: '13px',
          fontWeight: 700,
          color: '#334155',
          marginBottom: '8px',
        }}
      >
        ใบทะเบียนที่ได้รับอนุญาตขาย
      </div>
      {items.length > 0 ? (
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
          {items.map((license) => (
            <span
              key={license.license_id}
              className='badge badge-pill badge-info'
              style={{ fontSize: '12px', padding: '6px 10px' }}
            >
              {license.license_name}
            </span>
          ))}
        </div>
      ) : (
        <p style={{ margin: 0, fontSize: '13px', color: '#64748b' }}>
          ยังไม่ได้รับอนุญาตใบทะเบียน — ติดต่อ Line @meya
        </p>
      )}
    </div>
  );
}

ShopSellLicensesPanel.propTypes = {
  licenses: PropTypes.arrayOf(
    PropTypes.shape({
      license_id: PropTypes.string,
      license_name: PropTypes.string,
    }),
  ),
};

export default ShopSellLicensesPanel;
